import { GameObject } from "../core/GameObject";
import { GameScene } from "../scenes/GameScene";

export class ProgressMeter extends GameObject {

	line: Phaser.GameObjects.Image;
	marker: Phaser.GameObjects.Image;

	constructor(scene: GameScene) {
		super(scene);

		const line = this.line = this.addImage("hudProgressLine");
		this.setSize(line.width, line.height);

		// const start = this.addImage("hudProgressStart");
		// start.x = -line.width / 2;

		const marker = this.marker = this.addImage("hudProgressMarker");
		marker.x = -line.width / 2;
		//marker.y -= marker.height / 2;
	}

	setProgress(amt: number): void {
		amt = Phaser.Math.Clamp(amt, 0, 1);
		this.marker.x = Phaser.Math.Linear(-this.line.width / 2, this.line.width / 2, amt);
	}

}